import { render } from "./Revenue.vue?vue&type=template&id=338b256c&scoped=true&ts=true"
import script from "./Revenue.vue?vue&type=script&lang=ts"
export * from "./Revenue.vue?vue&type=script&lang=ts"

import "./Revenue.vue?vue&type=style&index=0&id=338b256c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338b256c"]])

export default __exports__